import styled from 'styled-components';

import { T5D } from '../Text';

const Container = styled.div`
  ${T5D} {
    margin-bottom: 3rem;
    max-width: 97rem;
  }

  width: 100%;
  max-width: 97rem;
  margin-bottom: 6rem;
`;

export default Container;
